import { handleVote } from './voteHandler';

const handlers = [handleVote];

export const handleSocketMessage = (data, refs, setters, optionalParams) => {
  for (const handler of handlers) {
    if (handler(data, refs, setters, optionalParams)) return;
  }
  // console.warn('Unhandled action:', data.actionName);
};
